module.exports = [{
    name: 'Home',
    id: 'basic',
    icon: 'th-large',
    componentName: 'App'
}/*, {
    name: 'Call for Papers',
    id: 'cfp',
    componentName: 'CallForPapers'
}, {
        name: 'Dates',
        id: 'Dates',
        icon: 'wpforms',
        componentName: 'Dates'
}, {
    name: 'Organizers',
    id: 'Organizers',
    componentName: 'Organizers'
}*/]